import React from "react";
import AssetDashboard from "../../components/assets/Dashboard";

const AssetDashboardPage = () => {
  return (
    <>
      <AssetDashboard />
    </>
  );
};

export default AssetDashboardPage;
